import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, EMPTY, take, tap } from 'rxjs';

import { ClaimNumberService } from '../claim-number/claim-number.service';
import { NavService } from '../nav/nav.service';

/**
 * Service capable of logging out the user.
 *
 * @author Jesse Bloomster e020902
 */
@Injectable({
	providedIn: 'root'
})
export class LogoutService {
	private readonly logoutUrl = '/gateway/logout';

	/**
	 * @param http the Angular Http Client
	 * @param navService the navigation service
	 * @param claimNumberService the service to update the stored claim number
	 */
	constructor(
		private http: HttpClient,
		private navService: NavService,
		private claimNumberService: ClaimNumberService
	) {}

	/**
	 * Logout the given user.
	 */
	logout(): void {
		this.http
			.get(this.logoutUrl)
			.pipe(
				take(1),
				tap(() => {
					this.claimNumberService.updateClaimNumber(null);
					this.navService.toTrackAClaim();
				}),
				catchError(() => {
					this.claimNumberService.updateClaimNumber(null);
					this.navService.toTrackAClaim();
					return EMPTY;
				})
			)
			.subscribe();
	}
}
